import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify, {
  theme: {
    primary: "#ffa13a",
    accent: "#1e196a",
    error: "#ff2424",
    secondary: "#424242",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});
